import React from 'react';

const TopTracks = ({ tracks }) => {
  if (!tracks) return null;

  return (
    <div className="card">
      <div className="card-heading">
        <h1>tracks</h1>
        <span className="num">N° 07</span>
      </div>
      <div className="card-content">
        <ol>
          {tracks.slice(0, 25).map(track => (
            <li key={track.name}>
              <span className="track-name">{track.name}</span>
              <span className="plays-count">{track.playcount}</span>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
};

export default TopTracks;
